import { Card, CardContent, Typography, Box, Divider } from '@mui/material'
import GoogleIcon from '../../../../components/icon/GoogleIcon'
import AssignedUsersPreview from '../charts/AssignedUsersPreview'

export default function VisitAssignedUsersCard({
  title = 'USUARIOS ASIGNADOS',
  total = 0,
  users = [],
  onViewAll
}) {
  return (
    <Card
      elevation={4}
      sx={{
        borderRadius: 2,
        height: 250,
        width: 540,
        border: '3px solid #E4E4E4',
        boxShadow: 0
      }}
    >
      <CardContent
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 1 }}>
          <Typography
            sx={{
              fontSize: 40,
              fontWeight: 800,
              lineHeight: 1
            }}
          >
            {total}
          </Typography>

          <Typography
            sx={{
              fontWeight: 700,
              color: '#606060',
              mt: 0.5
            }}
          >
            {title}
          </Typography>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 0.5,
              mt: 0.5,
              cursor: 'pointer',
              color: '#4B6EA9'
            }}
            onClick={onViewAll}
          >
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 600,
                textDecoration: 'underline'
              }}
            >
              Lista completa
            </Typography>

            <GoogleIcon
              name="search"
              size={18}
              weight={600}
              color="#4B6EA9"
            />
          </Box>
        </Box>
        <AssignedUsersPreview users={users} />
      </CardContent>
    </Card>
  )
}
